<app-titulo [modulo]="titulo" [mostrar]="true"></app-titulo>

<div  >

<div class="container">
    <div class="d-flex justify-content-center mt-4">
        <div class="d-flex col-md-3 mt-2 me-5">
            <label class="mt-1 me-3">Aplicativo</label>
            <select class="form-select" aria-label="Default select example" [(ngModel)]="modelo1"
                (change)="func_seleccion($event, 1)">
                <option disabled value="0" class="color-gris">Escoja el aplicativo</option>
                <option *ngFor="let item of funcionalidades" value="{{ item.idAplicativo }}">{{ item.nombreAplicativo }}
                </option>
            </select>
        </div>
        <div class="d-flex col-md-3 mt-2 ms-5">
        </div>
    </div>
    <div class="d-flex justify-content-center mt-4">
        <div class="d-flex col-md-3 me-3">
            <label class="azul-titulos fw-bold">Rol(es) disponible(s) para la funcionalidad seleccionada</label>
        </div>
        <div class="d-flex col-md-1">
        </div>
        <div class="d-flex col-md-3">
            <label class="azul-titulos fw-bold">Rol(es) seleccionado(s)</label>
        </div>
    </div>
    <div class="d-flex justify-content-center mt-4">
        <div class="card col-md-3 mt-1 me-5 scroll-listas">
            <ul class="list-group col-md-12">
                <li class="list-group-item cursor" *ngFor="let item of list_roles_origen; let i=index"
                    value="{{ item.idRol }}" (click)="seleccionRolOrigen($event, i)"
                    [ngClass]="{'active': indiceRolOrigen === item.idRol}">
                    {{ item.nombreRol }}
                </li>
            </ul>
        </div>
        <div class="mt-3 align-self-center flex-column">
            <div class="mb-3">
                <a class="text-primary cursor" (click)="agregarRol()"><i class="fa-solid fa-circle-right fa-2x"></i></a>
            </div>
            <div class="mb-3">
                <a class="text-primary cursor" (click)="quitarRol()"><i class="fa-solid fa-circle-left fa-2x"></i></a>
            </div>
        </div>
        <div class="card col-md-3 mt-1 ms-5 scroll-listas">
            <ul class="list-group col-md-12">
                <li class="list-group-item cursor" *ngFor="let item of list_roles_destino; let i=index"
                    value="{{ item.idRol }}" (click)="seleccionRolDestino($event, i)"
                    [ngClass]="{'active': indiceRolDestino === item.idRol}">
                    {{ item.nombreRol }}
                </li>
            </ul>
        </div>
    </div>
    <div class="d-flex justify-content-center mt-4">
        <div class="d-flex col-md-4 mt-1 me-5">
            <label class="azul-titulos fw-bold col-md-4 align-self-center">Usuarios activos</label>
            <div class="input-group">
                <span class="input-group-text fondo-blanco color-gris radius-2 cursor" (click)="buscar(texto.value)">
                    <i class="fa-solid fa-magnifying-glass"></i>
                </span>
                <input type="text" class="form-control lineas-buscadores" placeholder="Nombre Funcionario" #texto id="caja">
                <span class="input-group-text fondo-blanco color-gris radius-1 cursor" (click)="borrar()" id="cancel">
                    <i class="fa-solid fa-circle-xmark"></i>
                </span>
            </div>
        </div>
        <div class="d-flex col-md-5 mt-1 ms-5">
        </div>
    </div>
  <div class="container">
    <div class="d-flex justify-content-center mt-4">
        <div class="col-lg-12 mt-4">
            <table class="table mt-2" id="tabla1" aria-describedby="mydesc">
                <thead class="fondo-gris">
                    <tr>
                        <th scope="col"><input type="checkbox" class="me-3" id="all" value="0"
                                (change)="todos($event)">Selección</th>
                        <th scope="col" class="text-center">Nombre funcionario</th>
                        <th scope="col" class="text-center">Nombre usuario</th>
                        <th scope="col" class="text-center">Cargo</th>
                        <th scope="col" class="text-center">Área</th>
                    </tr>
                </thead>
                <tbody class="tabla1body">
                    <tr *ngFor="let usuario of usuarios | paginate: {id: 'pager-1', itemsPerPage: 10, currentPage: paginaUsuarios }">
                        <td><input type="checkbox" [checked]="usuario.inicio" (change)="agregarUsuario($event)"
                                value="{{ usuario.idUsuario }}"></td>
                        <td class="text-center">{{ usuario.nombreUsuario }}</td>
                        <td class="text-center">{{ usuario.email }}</td>
                        <td class="text-center">{{ usuario.perfil }}</td>
                        <td class="text-center">{{ usuario.area }}</td>
                    </tr>
                </tbody>
            </table>
            <div class="d-flex justify-content-end mt-2">
              <pagination-controls id="pager-1" class="clase-paginador" (pageChange)="paginaUsuarios = $event" previousLabel="Anterior"
                                   nextLabel="Siguientes"></pagination-controls>
            </div>
        </div>
    </div>
  </div>
    <div class="d-flex justify-content-center mt-5 mb-3">
        <div class="d-flex justify-content-end col-md-10">
            <div class="me-2">
                <button class="btn btn-primary" (click)="guardar()">ASIGNAR</button>
            </div>
            <div class="ms-2">
                <button class="btn btn-primary" (click)="cancelar()">CANCELAR</button>
            </div>
        </div>
    </div>
</div>
<div class="container">
    <div class="d-flex justify-content-start mt-4">
        <div class="d-flex col-md-3 me-3">
            <label class="azul-titulos fw-bold">Ultimas asignaciones</label>
        </div>
    </div>
    <div class="d-flex justify-content-end mt-4">
        <div class="d-flex col-md-3 mt-2 me-5">
            <label class="col-md-8 mt-1 me-3">Registros por página</label>
            <select class="form-select col-xs-2" aria-label="Default select example" [(ngModel)]="tamanoPagina">
                <option disabled value="0" class="color-gris">Escoja el aplicativo</option>
                <option value=10>{{ 10 }}</option>
                <option value=20>{{ 20 }}</option>
                <option value=50>{{ 50 }}</option>
                <option value=100>{{ 100 }}</option>
                <option value=200>{{ 200 }}</option>
            </select>
        </div>
    </div>
    <div class="d-flex justify-content-center mt-4">
        <div class="col-lg-12 mt-4">
            <table class="table mt-2" id="tabla2" aria-describedby="mydesc">
                <thead class="fondo-gris">
                    <tr>
                        <th scope="col" class="text-center">Usuario</th>
                        <th scope="col" class="text-center">Código Aplicación</th>
                        <th scope="col" class="text-center">Aplicativo</th>
                        <th scope="col" class="text-center">Rol</th>
                        <th scope="col" class="text-center">Fecha y hora</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let accion of acciones | paginate: {id: 'pager-2', itemsPerPage: tamanoPagina, currentPage: paginaAcciones }">
                        <td class="text-left">{{ accion.usuario }}</td>
                        <td class="text-center">{{ accion.codAplicativo }}</td>
                        <td class="text-left">{{ accion.aplicativo }}</td>
                        <td class="text-left">{{ accion.rol }}</td>
                        <td class="text-center">{{ accion.fechaCreacion }}</td>
                    </tr>
                </tbody>
            </table>
            <div class="d-flex justify-content-end mt-2">
              <pagination-controls id="pager-2" class="clase-paginador2" (pageChange)="paginaAcciones = $event" previousLabel="Anterior"
                                   nextLabel="Siguiente"></pagination-controls>
            </div>
        </div>
    </div>
</div>

</div>
